/* ============================================================
   HULLE EC — カスタム JavaScript 集約
   Dawn の global.js 等は編集せず、追加挙動はここに集約する。
   ============================================================ */
(function () {
  'use strict';

  /* ヒーロー: emmi風 3点スライダー（中央大・左右見切れ・無限ループ・オートスライド） */
  function initHulleSlider(slider) {
    var viewport = slider.querySelector('[data-hulle-viewport]');
    var track = slider.querySelector('[data-hulle-track]');
    if (!track || !viewport) return;
    var real = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
    var N = real.length;
    if (!N) return;
    var dots = slider.querySelectorAll('[data-hulle-dots] .hulle-hero2__dot');
    var prev = slider.querySelector('[data-hulle-prev]');
    var next = slider.querySelector('[data-hulle-next]');
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var interval = (parseInt(slider.getAttribute('data-interval'), 10) || 5) * 1000;
    var loop = N > 1;

    /* 前後に全スライドを複製して無限ループ＆両脇の見切れを常に確保 */
    if (loop) {
      var afterClones = real.map(function (s) { var c = s.cloneNode(true); c.setAttribute('data-clone', '1'); return c; });
      var beforeClones = real.map(function (s) { var c = s.cloneNode(true); c.setAttribute('data-clone', '1'); return c; });
      afterClones.forEach(function (c) { track.appendChild(c); });
      for (var b = beforeClones.length - 1; b >= 0; b--) { track.insertBefore(beforeClones[b], track.firstChild); }
    }
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
    var dom = loop ? N : 0;
    var animating = false, timer = null;

    function gap() { var cs = getComputedStyle(track); return parseFloat(cs.columnGap || cs.gap) || 0; }
    function realIndex() { return loop ? (((dom - N) % N) + N) % N : dom; }
    function updateActive() {
      var ri = realIndex();
      for (var i = 0; i < slides.length; i++) slides[i].classList.toggle('is-active', i === dom);
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === ri);
    }
    function position(withTrans) {
      var slideW = slides[0].getBoundingClientRect().width;
      var vpW = viewport.getBoundingClientRect().width;
      var offset = (vpW - slideW) / 2 - dom * (slideW + gap());
      if (!withTrans) {
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + offset + 'px)';
        track.getBoundingClientRect(); /* reflow */
        track.style.transition = '';
      } else {
        track.style.transform = 'translateX(' + offset + 'px)';
      }
      updateActive();
    }
    function go(dir) { if (animating) return; dom += dir; if (loop) { animating = true; } position(true); }
    function toReal(ri) { if (animating) return; dom = loop ? N + ri : ri; position(true); }

    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      animating = false;
      if (loop) {
        if (dom < N) { dom += N; position(false); }
        else if (dom >= 2 * N) { dom -= N; position(false); }
      }
    });

    if (next) next.addEventListener('click', function () { go(1); start(); });
    if (prev) prev.addEventListener('click', function () { go(-1); start(); });
    for (var d = 0; d < dots.length; d++) {
      (function (n) { dots[n].addEventListener('click', function () { toReal(n); start(); }); })(d);
    }
    /* 脇のスライドをクリックしたらその方向へ送る（リンク誤遷移を防止） */
    for (var s = 0; s < slides.length; s++) {
      (function (n) {
        slides[n].addEventListener('click', function (e) {
          if (n !== dom) { e.preventDefault(); go(n < dom ? -1 : 1); start(); }
        });
      })(s);
    }
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      x0 = null; start();
    });

    function start() { stop(); if (autoplay && loop) timer = window.setInterval(function () { go(1); }, interval); }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    window.addEventListener('resize', function () { position(false); });
    if (window.ResizeObserver) { new ResizeObserver(function () { position(false); }).observe(viewport); }
    position(false);
    start();
  }

  /* 共通ヘッダー: 常時追従（sticky）＋トップは透過→スクロールでソリッド化 */
  function initHeader() {
    var h = document.querySelector('[data-hulle-header]');
    if (!h) return;
    var overlay = h.getAttribute('data-overlay') === 'true';
    /* ヘッダーグループ内のキャンペーン帯は fixed。その高さ分ヘッダー/本文を下げる */
    var band = document.querySelector('.shopify-section-group-header-group .hulle-campaign');
    var ticking = false;
    function update() {
      var y = window.scrollY;
      if (overlay) h.classList.toggle('is-solid', y > 60);
      document.documentElement.style.setProperty('--hulle-campaign-h', (band ? band.offsetHeight : 0) + 'px');
      document.documentElement.style.setProperty('--hulle-header-h', h.offsetHeight + 'px');
      ticking = false;
    }
    if (band && window.ResizeObserver) { new ResizeObserver(update).observe(band); }
    update();
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update);
  }

  /* 一覧カード: カード全面クリックで商品詳細へ遷移（クイック追加ボタンは除外） */
  function initCardClick() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-quickadd]')) return;     /* カート追加ボタンは自身で処理 */
      if (e.target.closest('a, button')) return;           /* 実リンク/ボタンはそのまま */
      var card = e.target.closest('.hulle-card');
      if (!card) return;
      var link = card.querySelector('.hulle-card__link[href]');
      if (link) window.location.href = link.getAttribute('href');
    });
  }

  /* 一覧カード: ホバー・クイック追加（AJAX /cart/add.js） */
  function hulleCartCount(n) {
    var el = document.querySelector('[data-hulle-cart-count]');
    var cart = document.querySelector('.hulle-header__cart');
    if (el) { el.textContent = n; }
    else if (cart && n > 0) {
      var s = document.createElement('span');
      s.className = 'hulle-header__cart-count'; s.setAttribute('data-hulle-cart-count', ''); s.textContent = n;
      cart.appendChild(s);
    }
    if (cart) { cart.classList.remove('is-bump'); void cart.offsetWidth; cart.classList.add('is-bump'); }
  }
  function hulleToast(msg) {
    var t = document.createElement('div');
    t.className = 'hulle-toast'; t.textContent = msg;
    document.body.appendChild(t);
    window.requestAnimationFrame(function () { t.classList.add('is-show'); });
    window.setTimeout(function () { t.classList.remove('is-show'); window.setTimeout(function () { t.remove(); }, 320); }, 2000);
  }
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quickadd]');
      if (!btn || btn.classList.contains('is-soldout') || btn.classList.contains('is-loading')) return;
      e.preventDefault();
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
      var label = btn.querySelector('.hulle-card__quickadd-label');
      var orig = label ? label.textContent : '';
      btn.classList.add('is-loading');
      if (label) label.textContent = '追加中...';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          btn.classList.remove('is-loading'); btn.classList.add('is-added');
          if (label) label.textContent = '追加しました✓';
          hulleCartCount(cart.item_count);
          hulleToast('カートに追加しました');
          window.setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = orig; }, 1800);
        }).catch(function () {
          btn.classList.remove('is-loading');
          if (label) { label.textContent = '追加できませんでした'; window.setTimeout(function () { label.textContent = orig; }, 1800); }
        });
    });
  }

  /* キャンペーン帯: カウントダウン */
  function initCampaignCountdown() {
    var els = document.querySelectorAll('[data-hulle-campaign]');
    for (var i = 0; i < els.length; i++) {
      (function (el) {
        var end = el.getAttribute('data-end');
        var cd = el.querySelector('[data-hulle-countdown]');
        if (!end || !cd) return;
        var endT = new Date(end.replace(' ', 'T')).getTime();
        if (isNaN(endT)) return;
        var dD = cd.querySelector('[data-cd-d]'), dH = cd.querySelector('[data-cd-h]'), dM = cd.querySelector('[data-cd-m]'), dS = cd.querySelector('[data-cd-s]');
        function pad(n) { return n < 10 ? '0' + n : '' + n; }
        var timer = window.setInterval(tick, 1000);
        function tick() {
          var diff = endT - Date.now();
          if (diff <= 0) { el.style.display = 'none'; window.clearInterval(timer); window.dispatchEvent(new Event('resize')); return; }
          var s = Math.floor(diff / 1000);
          dD.textContent = Math.floor(s / 86400);
          dH.textContent = pad(Math.floor((s % 86400) / 3600));
          dM.textContent = pad(Math.floor((s % 3600) / 60));
          dS.textContent = pad(s % 60);
          cd.hidden = false;
        }
        tick();
      })(els[i]);
    }
  }

  /* ページトップへ戻るボタン */
  function initBackToTop() {
    var btn = document.createElement('button');
    btn.className = 'hulle-totop';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'ページトップへ戻る');
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M7 14l5-5 5 5"/></svg>';
    document.body.appendChild(btn);
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    function onScroll() { btn.classList.toggle('is-shown', window.scrollY > 600); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* 共通ヘッダー: SPドロワー（開閉・アコーディオン） */
  function initHeaderDrawer() {
    var drawer = document.querySelector('[data-hulle-drawer]');
    if (!drawer) return;
    var openBtns = document.querySelectorAll('[data-hulle-drawer-open]');
    var closeEls = drawer.querySelectorAll('[data-hulle-drawer-close]');
    function open() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('hulle-no-scroll'); }
    function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('hulle-no-scroll'); }
    for (var i = 0; i < openBtns.length; i++) openBtns[i].addEventListener('click', open);
    for (var j = 0; j < closeEls.length; j++) closeEls[j].addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var accs = drawer.querySelectorAll('[data-hulle-acc-toggle]');
    for (var k = 0; k < accs.length; k++) {
      accs[k].addEventListener('click', function () {
        var group = this.closest('[data-hulle-acc]');
        var expanded = group.classList.toggle('is-open');
        this.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }
  }

  /* 商品: 最近見たアイテム（localStorage + /products/{handle}.js） */
  function initRecentlyViewed() {
    var box = document.querySelector('[data-hulle-recent]');
    var handle = box ? box.getAttribute('data-current') : null;
    var KEY = 'hulle_recent';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    if (handle) {
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      list = list.slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    if (!box) return;
    var grid = box.querySelector('[data-hulle-recent-grid]');
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 5;
    var others = list.filter(function (h) { return h !== handle; }).slice(0, limit);
    if (!others.length || !grid) return;
    var done = 0, parts = [];
    others.forEach(function (h, i) {
      fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var onSale = p.compare_at_price && p.compare_at_price > p.price;
          var off = onSale ? Math.round((p.compare_at_price - p.price) / p.compare_at_price * 100) : 0;
          var priceYen = '¥' + Math.round(p.price / 100).toLocaleString('ja-JP');
          var wasYen = onSale ? '¥' + Math.round(p.compare_at_price / 100).toLocaleString('ja-JP') : '';
          var tags = Array.isArray(p.tags) ? p.tags : (p.tags || '').split(',');
          var isNew = tags.some(function (t) { return String(t).trim().toLowerCase() === 'new'; });
          var badges = '';
          if (onSale) badges += '<span class="hulle-card__badge hulle-card__badge--sale">' + off + '%OFF</span>';
          if (isNew) badges += '<span class="hulle-card__badge hulle-card__badge--new">NEW</span>';
          var priceHtml = onSale
            ? '<p class="hulle-card__price hulle-card__price--sale">' + priceYen + '<span class="hulle-card__price-was">' + wasYen + '</span></p>'
            : '<p class="hulle-card__price">' + priceYen + '</p>';
          var vid = (p.variants && p.variants[0] && p.variants[0].id) || '';
          var soldout = !p.available;
          var qa = (p.available && vid)
            ? '<button class="hulle-card__quickadd" type="button" data-quickadd data-variant-id="' + vid + '"><span class="hulle-card__quickadd-label">カートに追加</span></button>'
            : '<span class="hulle-card__soldout">SOLD OUT</span>';
          parts[i] = '<div class="hulle-card" data-card>' +
            '<a class="hulle-card__link" href="' + p.url + '" aria-label="' + (p.title || '') + '"></a>' +
            '<div class="hulle-card__media' + (soldout ? ' is-soldout' : '') + '"><div class="hulle-card__badges">' + badges + '</div>' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + qa + '</div>' +
            '<div class="hulle-card__body"><div class="hulle-card__info"><span class="hulle-card__brand">' + (p.vendor || '') + '</span></div>' +
            '<p class="hulle-card__name">' + (p.title || '') + '</p>' + priceHtml + '</div></div>';
        }
        done++;
        if (done === others.length) {
          var html = parts.filter(Boolean).join('');
          if (html) { grid.innerHTML = html; box.classList.add('is-shown'); }
        }
      }).catch(function () { done++; });
    });
  }

  /* 商品一覧: テーマ内蔵ライブ絞り込み（ブランド/カラー/サイズ/価格/カテゴリ） */
  function initCollectionFilter() {
    var root = document.querySelector('[data-hulle-collfilter]');
    if (!root) return;
    var grid = root.querySelector('[data-coll-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
    if (!cards.length) return;
    var totalEl = root.querySelector('[data-coll-total]');
    var rangeEl = root.querySelector('[data-coll-range]');
    var pagerEl = root.querySelector('[data-coll-pager]');
    var pageSize = parseInt(grid.getAttribute('data-coll-pagesize'), 10) || 48;
    var curPage = 1;
    var serverPages = parseInt(grid.getAttribute('data-coll-server-pages'), 10) || 1;
    var sectionId = grid.getAttribute('data-coll-section-id') || '';
    var loadingMore = serverPages > 1;
    var chipsEl = root.querySelector('[data-coll-chips]');
    var emptyEl = root.querySelector('[data-coll-empty]');
    var sortSel = root.querySelector('[data-coll-sort]');
    var controls = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var searchBox = root.querySelector('[data-coll-search]');
    var qstr = '';
    var GROUPS = ['brand', 'color', 'size', 'price', 'type'];
    var PARAM = { brand: 'b', color: 'color', size: 'size', price: 'price', type: 'type' };
    var priceLabel = { '0-9999': '〜¥9,999', '10000-19999': '¥10,000〜¥19,999', '20000-29999': '¥20,000〜¥29,999', '30000-9999999': '¥30,000〜' };
    var state = {}; GROUPS.forEach(function (g) { state[g] = []; });
    var origOrder = cards.slice();
    function grp(c) { return c.getAttribute('data-filter'); }
    function val(c) { return c.getAttribute('value'); }
    function setActive(c, on) {
      if (c.tagName === 'INPUT') { c.checked = on; }
      else { c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); }
    }
    function toggle(g, v, on) { var a = state[g], i = a.indexOf(v); if (on && i < 0) a.push(v); if (!on && i >= 0) a.splice(i, 1); }
    function inPrice(yen, buckets) { return buckets.some(function (b) { var a = b.split('-'); return yen >= +a[0] && yen <= +a[1]; }); }
    function matches(c) {
      if (qstr && (c.getAttribute('data-search') || '').indexOf(qstr) < 0) return false;
      if (state.brand.length && state.brand.indexOf(c.getAttribute('data-vendor')) < 0) return false;
      if (state.color.length && state.color.indexOf(c.getAttribute('data-color')) < 0) return false;
      if (state.size.length) { var cs = (c.getAttribute('data-sizes') || '').split(','); if (!state.size.some(function (s) { return cs.indexOf(s) >= 0; })) return false; }
      if (state.price.length && !inPrice(+c.getAttribute('data-price'), state.price)) return false;
      if (state.type.length && state.type.indexOf(c.getAttribute('data-type')) < 0) return false;
      return true;
    }
    function renderChips() {
      if (!chipsEl) return;
      var html = '', any = false;
      GROUPS.forEach(function (g) {
        state[g].forEach(function (v) {
          any = true;
          var lbl = g === 'price' ? (priceLabel[v] || v) : v;
          html += '<button class="hulle-coll__chip" data-chip-g="' + g + '" data-chip-v="' + v.replace(/"/g, '&quot;') + '">' + lbl + ' <span>×</span></button>';
        });
      });
      chipsEl.innerHTML = html; chipsEl.hidden = !any;
    }
    function writeURL() {
      var q = new URLSearchParams(location.search);
      var keep = q.get('page'); // サーバー側ページ (250件超) は保持
      q = new URLSearchParams();
      if (keep) q.set('page', keep);
      if (qstr) q.set('q', qstr);
      GROUPS.forEach(function (g) { if (state[g].length) q.set(PARAM[g], state[g].join(',')); });
      if (sortSel && sortSel.value) q.set('sort', sortSel.value);
      if (curPage > 1) q.set('p', String(curPage));
      var qs = q.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
    }
    /* 後続サーバーページ (250件超) を自動読込して1つの一覧に統合する */
    function bindControl(c) {
      var g = grp(c), v = val(c);
      if (c.tagName === 'INPUT') c.addEventListener('change', function () { toggle(g, v, c.checked); apply(); });
      else c.addEventListener('click', function () { var on = !c.classList.contains('is-active'); setActive(c, on); toggle(g, v, on); apply(); });
    }
    function addFacetOption(g, v, hex) {
      if (!v) return;
      var exists = controls.some(function (c) { return grp(c) === g && val(c) === v; });
      if (exists) return;
      var group = root.querySelector('[data-filter="' + g + '"]');
      if (!group) return; // そのグループ自体が無いページ構成なら追加しない
      var container = group.closest('.hulle-coll__opts, .hulle-coll__swatches, .hulle-coll__pills');
      if (!container) return;
      var el;
      if (g === 'color') {
        el = document.createElement('button');
        el.type = 'button'; el.className = 'hulle-coll__swatch';
        el.setAttribute('data-filter', 'color'); el.setAttribute('value', v);
        el.title = v; el.setAttribute('aria-label', v);
        el.innerHTML = '<span class="hulle-coll__swatch-dot" style="background: ' + (hex || '#cccccc') + ';"></span><span class="hulle-coll__swatch-label"></span>';
        el.querySelector('.hulle-coll__swatch-label').textContent = v;
      } else if (g === 'size') {
        el = document.createElement('button');
        el.type = 'button'; el.className = 'hulle-coll__pill';
        el.setAttribute('data-filter', 'size'); el.setAttribute('value', v);
        el.textContent = v;
      } else {
        el = document.createElement('label');
        el.className = 'hulle-coll__check';
        var input = document.createElement('input');
        input.type = 'checkbox'; input.setAttribute('data-filter', g); input.setAttribute('value', v);
        var span = document.createElement('span'); span.textContent = v;
        el.appendChild(input); el.appendChild(span);
        container.appendChild(el);
        controls.push(input); bindControl(input);
        setActive(input, state[g].indexOf(v) >= 0);
        return;
      }
      container.appendChild(el);
      controls.push(el); bindControl(el);
      setActive(el, state[g].indexOf(v) >= 0);
    }
    function absorbCards(nodes) {
      nodes.forEach(function (c) {
        c.style.display = 'none';
        grid.appendChild(c);
        cards.push(c); origOrder.push(c);
        addFacetOption('brand', c.getAttribute('data-vendor'));
        addFacetOption('color', c.getAttribute('data-color'), c.getAttribute('data-color-hex'));
        (c.getAttribute('data-sizes') || '').split(',').forEach(function (sz) { if (sz) addFacetOption('size', sz); });
        addFacetOption('type', c.getAttribute('data-type'));
      });
    }
    function loadRemainingPages() {
      if (serverPages <= 1) return;
      var next = 2;
      function loadNext() {
        if (next > serverPages) { loadingMore = false; apply(true); return; }
        var u = new URL(location.href);
        u.searchParams.set('page', String(next));
        if (sectionId) u.searchParams.set('section_id', sectionId);
        fetch(u.toString())
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var extra = Array.prototype.slice.call(doc.querySelectorAll('[data-card]'));
            absorbCards(extra);
            next++;
            apply(true);
            loadNext();
          })
          .catch(function () { loadingMore = false; apply(true); });
      }
      loadNext();
    }

    /* ページャー: 「‹ 前へ 1 2 … N 次へ ›」を描画 (国内ECの定番構成) */
    function renderPager(totalPages) {
      if (!pagerEl) return;
      if (totalPages <= 1) { pagerEl.hidden = true; pagerEl.innerHTML = ''; return; }
      var html = '';
      html += '<button type="button" class="hulle-coll__page-btn hulle-coll__page-prev" data-page="' + (curPage - 1) + '"' + (curPage <= 1 ? ' disabled' : '') + ' aria-label="前のページ">‹ 前へ</button>';
      // 表示するページ番号: 先頭/末尾 + 現在ページの前後1 (間は …)
      var nums = [], last = 0;
      for (var i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || Math.abs(i - curPage) <= 1) nums.push(i);
      }
      nums.forEach(function (n) {
        if (last && n - last > 1) html += '<span class="hulle-coll__page-gap">…</span>';
        if (n === curPage) html += '<span class="hulle-coll__page-btn is-current" aria-current="page">' + n + '</span>';
        else html += '<button type="button" class="hulle-coll__page-btn" data-page="' + n + '" aria-label="' + n + 'ページ目">' + n + '</button>';
        last = n;
      });
      html += '<button type="button" class="hulle-coll__page-btn hulle-coll__page-next" data-page="' + (curPage + 1) + '"' + (curPage >= totalPages ? ' disabled' : '') + ' aria-label="次のページ">次へ ›</button>';
      pagerEl.innerHTML = html;
      pagerEl.hidden = false;
    }
    function sortCompare(sortValue) {
      return function (a, b) {
        switch (sortValue) {
          case 'price-asc': return +a.getAttribute('data-price') - +b.getAttribute('data-price');
          case 'price-desc': return +b.getAttribute('data-price') - +a.getAttribute('data-price');
          case 'newest': return +b.getAttribute('data-created') - +a.getAttribute('data-created');
          case 'title-asc': return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '', 'ja');
          case 'title-desc': return (b.getAttribute('data-title') || '').localeCompare(a.getAttribute('data-title') || '', 'ja');
          default: return 0;
        }
      };
    }
    function apply(keepPage) {
      var pool = sortSel && sortSel.value
        ? cards.slice().sort(sortCompare(sortSel.value))
        : origOrder;
      var visible = pool.filter(matches);
      if (!keepPage) curPage = 1;
      var totalPages = Math.max(1, Math.ceil(visible.length / pageSize));
      if (curPage > totalPages) curPage = totalPages;
      var from = (curPage - 1) * pageSize;
      var to = Math.min(visible.length, from + pageSize);
      var pageSet = visible.slice(from, to);
      cards.forEach(function (c) { c.style.display = pageSet.indexOf(c) >= 0 ? '' : 'none'; });
      pool.forEach(function (c) { grid.appendChild(c); });
      var anyFilter = qstr || GROUPS.some(function (g) { return state[g].length > 0; });
      var serverTotal = parseInt(grid.getAttribute('data-coll-total-count'), 10) || visible.length;
      var shownTotal = !anyFilter && loadingMore ? Math.max(visible.length, serverTotal) : visible.length;
      if (totalEl) totalEl.textContent = shownTotal;
      if (rangeEl) rangeEl.textContent = visible.length ? (from + 1) + '〜' + to : '0';
      if (emptyEl) emptyEl.hidden = visible.length > 0;
      renderPager(totalPages);
      renderChips(); writeURL();
    }
    controls.forEach(bindControl);
    if (pagerEl) pagerEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-page]');
      if (!btn || btn.disabled) return;
      curPage = parseInt(btn.getAttribute('data-page'), 10) || 1;
      apply(true);
      // ページ送り後は一覧の先頭へ (sticky バーの分だけ上に余裕を持たせる)
      var top = grid.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: top > 0 ? top : 0, behavior: 'smooth' });
    });
    if (sortSel) sortSel.addEventListener('change', function () { apply(); });
    if (searchBox) searchBox.addEventListener('input', function () { qstr = searchBox.value.toLowerCase().trim(); apply(); });
    if (chipsEl) chipsEl.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-chip-g]'); if (!chip) return;
      var g = chip.getAttribute('data-chip-g'), v = chip.getAttribute('data-chip-v');
      toggle(g, v, false);
      controls.forEach(function (c) { if (grp(c) === g && val(c) === v) setActive(c, false); });
      apply();
    });
    var clearBtn = root.querySelector('[data-coll-clear]');
    if (clearBtn) clearBtn.addEventListener('click', function () {
      GROUPS.forEach(function (g) { state[g] = []; });
      controls.forEach(function (c) { setActive(c, false); });
      if (sortSel) sortSel.value = '';
      qstr = ''; if (searchBox) searchBox.value = '';
      apply();
    });
    Array.prototype.slice.call(root.querySelectorAll('[data-coll-open]')).forEach(function (b) {
      b.addEventListener('click', function () { root.classList.add('is-filter-open'); document.documentElement.classList.add('hulle-no-scroll'); });
    });
    Array.prototype.slice.call(root.querySelectorAll('[data-coll-close]')).forEach(function (b) {
      b.addEventListener('click', function () { root.classList.remove('is-filter-open'); document.documentElement.classList.remove('hulle-no-scroll'); });
    });
    // init from URL
    var q = new URLSearchParams(location.search);
    var qp = q.get('q'); if (qp) { qstr = qp.toLowerCase().trim(); if (searchBox) searchBox.value = qp; }
    GROUPS.forEach(function (g) { var v = q.get(PARAM[g]); if (v) state[g] = v.split(',').filter(Boolean); });
    if (sortSel) { var s = q.get('sort'); if (s) sortSel.value = s; }
    var pp = parseInt(q.get('p'), 10); if (pp > 1) curPage = pp;
    controls.forEach(function (c) { setActive(c, state[grp(c)].indexOf(val(c)) >= 0); });
    apply(true);
    loadRemainingPages();
  }

  /* SNAP詳細: ホットスポット（丸印）のポップアップ開閉 */
  function initSnapHotspots() {
    var scopes = document.querySelectorAll('[data-hulle-snap]');
    if (!scopes.length) return;
    for (var s = 0; s < scopes.length; s++) {
      (function (scope) {
        scope.addEventListener('click', function (e) {
          var dot = e.target.closest('[data-hulle-dot]');
          if (!dot) return;
          e.preventDefault();
          var hotspot = dot.parentNode;
          var wasOpen = hotspot.classList.contains('is-open');
          var open = scope.querySelectorAll('.hulle-snap__hotspot.is-open');
          for (var i = 0; i < open.length; i++) open[i].classList.remove('is-open');
          if (!wasOpen) hotspot.classList.add('is-open');
          if (scope.hasAttribute('data-hulle-marquee')) {
            scope.classList.toggle('is-paused', !wasOpen);
          }
        });
      })(scopes[s]);
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.hulle-snap__hotspot')) {
        var open = document.querySelectorAll('.hulle-snap__hotspot.is-open');
        for (var i = 0; i < open.length; i++) open[i].classList.remove('is-open');
        var paused = document.querySelectorAll('.hulle-snapmq.is-paused');
        for (var j = 0; j < paused.length; j++) paused[j].classList.remove('is-paused');
      }
    });
  }

  /* SNAP詳細: 画像ギャラリーのサムネ切替 */
  function initSnapGallery() {
    var gals = document.querySelectorAll('[data-snapgallery]');
    for (var g = 0; g < gals.length; g++) {
      (function (gal) {
        var main = gal.querySelector('[data-snapgallery-main]');
        var thumbs = gal.querySelectorAll('.hulle-snapgallery__thumb');
        if (!main || !thumbs.length) return;
        for (var t = 0; t < thumbs.length; t++) {
          thumbs[t].addEventListener('click', function () {
            var full = this.getAttribute('data-full');
            if (full) { main.removeAttribute('srcset'); main.src = full; }
            for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.remove('is-active');
            this.classList.add('is-active');
          });
        }
      })(gals[g]);
    }
  }

  function initStoreFinder() {
    var root = document.querySelector('[data-hulle-stores]');
    if (!root) return;
    var tabs = root.querySelectorAll('.hulle-stores__tab');
    var cards = root.querySelectorAll('[data-store]');

    function filter(area) {
      for (var i = 0; i < cards.length; i++) {
        var show = area === 'all' || cards[i].getAttribute('data-area') === area;
        cards[i].hidden = !show;
      }
    }
    for (var t = 0; t < tabs.length; t++) {
      tabs[t].addEventListener('click', function () {
        for (var k = 0; k < tabs.length; k++) {
          tabs[k].classList.remove('is-active');
          tabs[k].setAttribute('aria-selected', 'false');
        }
        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');
        filter(this.getAttribute('data-area'));
      });
    }

    function toggle(card, open) {
      var head = card.querySelector('[data-store-toggle]');
      var detail = card.querySelector('.hulle-stores__detail');
      if (!head || !detail) return;
      var willOpen = typeof open === 'boolean' ? open : detail.hidden;
      detail.hidden = !willOpen;
      head.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      card.classList.toggle('is-open', willOpen);
    }
    for (var c = 0; c < cards.length; c++) {
      (function (card) {
        var head = card.querySelector('[data-store-toggle]');
        if (head) head.addEventListener('click', function () { toggle(card); });
      })(cards[c]);
    }

    // ハッシュ深リンク（/pages/shop#store-xxx）で該当店舗を開いてスクロール
    if (location.hash && location.hash.indexOf('#store-') === 0) {
      var target = document.getElementById(location.hash.slice(1));
      if (target && target.hasAttribute('data-store')) {
        toggle(target, true);
        target.scrollIntoView({ block: 'center' });
      }
    }
  }

  function initSizeGuide() {
    var trigger = document.querySelector('[data-sizeguide-open]');
    var modal = document.querySelector('[data-sizeguide-modal]');
    if (!trigger || !modal) return;
    // Dawnの商品情報カラム（contain/transform 祖先）に拘束されないよう body 直下へ移動し、
    // position:fixed をビューポート基準にする
    document.body.appendChild(modal);
    function open() { modal.hidden = false; document.documentElement.classList.add('hulle-no-scroll'); }
    function close() { modal.hidden = true; document.documentElement.classList.remove('hulle-no-scroll'); }
    trigger.addEventListener('click', open);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-sizeguide-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function initStoreZoom() {
    var modal = document.querySelector('[data-store-zoom-modal]');
    if (!modal) return;
    var img = modal.querySelector('[data-store-zoom-img]');
    if (!img) return;
    document.body.appendChild(modal);
    function open(src, alt) {
      img.src = src;
      img.alt = alt || '';
      modal.hidden = false;
      document.documentElement.classList.add('hulle-no-scroll');
    }
    function close() {
      modal.hidden = true;
      document.documentElement.classList.remove('hulle-no-scroll');
      img.removeAttribute('src');
      img.alt = '';
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-store-zoom]');
      if (!btn) return;
      var src = btn.getAttribute('data-src');
      if (!src) return;
      open(src, btn.getAttribute('data-alt') || '');
    });
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-store-zoom-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function initNewsletterPopup() {
    var pop = document.querySelector('[data-nlpop]');
    if (!pop) return;
    var KEY = 'hulle_nl_dismissed';   // 完全終了
    var MKEY = 'hulle_nl_minimized';  // 中央を一度閉じた（以降は左下タブのみ）
    var cooldownMs = (parseInt(pop.getAttribute('data-cooldown'), 10) || 0) * 86400000;
    function getTs(k) { try { return parseInt(localStorage.getItem(k), 10) || 0; } catch (e) { return 0; } }
    function setTs(k) { try { localStorage.setItem(k, String(Date.now())); } catch (e) {} }
    function openFull() {
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); pop.classList.remove('is-mini'); });
    }
    function showMini() {
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-mini'); pop.classList.remove('is-open'); });
    }
    function minimize() {
      // ×: 完全には消さず左下タブに最小化。以降は中央を自動表示しない
      pop.classList.remove('is-open');
      pop.classList.add('is-mini');
      setTs(MKEY);
    }
    function fullClose() {
      pop.classList.remove('is-open');
      pop.classList.remove('is-mini');
      setTs(KEY);
      setTimeout(function () { pop.hidden = true; }, 300);
    }
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-nlpop-fullclose]')) { fullClose(); return; }
      if (e.target.closest('[data-nlpop-open]')) { openFull(); return; }
      if (e.target.closest('[data-nlpop-close]')) { minimize(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop.classList.contains('is-open')) minimize();
    });
    // 登録完了時はクーポンを見せるため必ず中央表示
    if (pop.querySelector('[data-nlpop-success]')) { openFull(); return; }
    var now = Date.now();
    if (cooldownMs > 0 && now - getTs(KEY) < cooldownMs) return;            // 完全終了 → 何も出さない
    if (cooldownMs > 0 && getTs(MKEY) && now - getTs(MKEY) < cooldownMs) { showMini(); return; } // 一度閉じた → 左下タブのみ
    var delay = parseInt(pop.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 1500;
    setTimeout(openFull, delay);                                            // 初回 → 中央表示
  }

  /* キャンペーンLP: SP追従CTA。KVを通り過ぎたら出し、フッター手前で引っ込める。 */
  function initStickyCta() {
    var bar = document.querySelector('[data-hulle-sticky-cta]');
    if (!bar) return;
    var hero = document.querySelector('.hulle-cvhero');
    var ticking = false;
    function update() {
      ticking = false;
      var trigger = hero ? hero.offsetTop + hero.offsetHeight * 0.6 : window.innerHeight * 0.4;
      var show = window.scrollY > trigger;
      if (show && bar.hidden) bar.hidden = false;
      bar.classList.toggle('is-visible', show);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    // 登録完了パネルが出ている＝目的達成済みなので追従CTAは出さない
    if (document.querySelector('.hulle-nlsuccess')) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* クーポンコードのコピー */
  function initCopyCode() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy-code]');
      if (!btn) return;
      var code = btn.getAttribute('data-copy-code') || '';
      if (!code) return;
      var done = function () {
        var original = btn.getAttribute('data-original-label') || btn.textContent;
        btn.setAttribute('data-original-label', original);
        btn.textContent = 'コピーしました';
        btn.classList.add('is-copied');
        window.setTimeout(function () {
          btn.textContent = original;
          btn.classList.remove('is-copied');
        }, 2000);
      };
      // Clipboard API は権限やコンテキスト次第で拒否されるため、必ず execCommand へフォールバックする
      var fallback = function () {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '0';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, code.length);
        try { document.execCommand('copy'); done(); } catch (err) {}
        document.body.removeChild(ta);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, fallback);
        return;
      }
      fallback();
    });
  }

  function init() {
    var sliders = document.querySelectorAll('[data-hulle-slider]');
    for (var i = 0; i < sliders.length; i++) initHulleSlider(sliders[i]);
    initHeader();
    initBackToTop();
    initCampaignCountdown();
    initQuickAdd();
    initCardClick();
    initHeaderDrawer();
    initRecentlyViewed();
    initCollectionFilter();
    initSnapHotspots();
    initSnapGallery();
    initStoreFinder();
    initSizeGuide();
    initStoreZoom();
    initNewsletterPopup();
    initStickyCta();
    initCopyCode();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

/* Ranking カテゴリタブ (hulle-ranking-tabs) の切替。
   タブで対応パネルを表示し、左カラムの View all リンクも選択中コレクションへ差し替える。 */
document.addEventListener('click', (e) => {
  const tab = e.target.closest('.hulle-rtabs__tab');
  if (!tab) return;
  const root = tab.closest('[data-hulle-rtabs]');
  if (!root) return;
  const key = tab.getAttribute('data-rtab');
  root.querySelectorAll('.hulle-rtabs__tab').forEach((t) => {
    const on = t === tab;
    t.classList.toggle('is-active', on);
    t.setAttribute('aria-selected', on ? 'true' : 'false');
  });
  let viewallUrl = '';
  root.querySelectorAll('.hulle-rtabs__panel').forEach((p) => {
    const on = p.getAttribute('data-rtab-panel') === key;
    p.classList.toggle('is-active', on);
    if (on) {
      p.removeAttribute('hidden');
      viewallUrl = p.getAttribute('data-viewall-url') || '';
    } else {
      p.setAttribute('hidden', '');
    }
  });
  const viewall = root.closest('.hulle-pgrid-wrap')?.querySelector('[data-rtabs-viewall]');
  if (viewall && viewallUrl) viewall.setAttribute('href', viewallUrl);
});
